import { API_BASE_API_QA_URL, API_BASE_API_SSO_URL } from '../urls';

export const API_QA_FETCH_TABLE = `${API_BASE_API_QA_URL}docs/list`;
export const API_QA_FETCH_CATEGORIES = `${API_BASE_API_QA_URL}docs/categories/list`;
export const API_QA_ADD_BLOCK = `${API_BASE_API_QA_URL}docs/categories/add`;
export const API_QA_DELETE_BLOCK = `${API_BASE_API_QA_URL}docs/categories/delete`;
export const API_QA_EDIT_BLOCK = `${API_BASE_API_QA_URL}docs/categories/update`;
export const API_QA_UPDATE_SEQUENCE = `${API_BASE_API_QA_URL}docs/update-list-order`;
export const API_QA_GET_UPLOAD_FILE_LINK = `${API_BASE_API_QA_URL}media/public-upload`;
export const API_QA_DELETE_FILE = `${API_BASE_API_QA_URL}media/public-delete`;
export const API_QA_DELETE_EDIT_FILE = `${API_BASE_API_QA_URL}docs/delete-file`;
export const API_QA_CREATE_QUESTION = `${API_BASE_API_QA_URL}docs/add`;
export const API_QA_DELETE_QUESTION = `${API_BASE_API_QA_URL}docs/delete`;
export const API_QA_VISIBLE_QUESTION = `${API_BASE_API_QA_URL}docs/update-active`;
export const API_QA_AVAILABLE_QUESTION = `${API_BASE_API_QA_URL}docs/update-available`;
export const API_QA_VISIBILITY_BLOCK = `${API_BASE_API_QA_URL}docs/categories/update-visibility`;
export const API_QA_GET_QUESTION_EDIT = `${API_BASE_API_QA_URL}docs/view`;
export const API_QA_QUESTION_EDIT = `${API_BASE_API_QA_URL}docs/update`;

export const API_BASE_MAILING_URL = `${API_BASE_API_SSO_URL}/tt-mail-sender/api`;
